import React from 'react';
import styled from 'styled-components';
import FeatureSquare from './components/FeatureSquare';
import { useAccount } from '../../../context/AccountContext';


const PageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;
  margin-top: 40px;
`;

const GetStartedPage = () => {
  const { activePlan } = useAccount();
  const features = [
     {
      title: 'NPS Survey Analysis',
      description: 'Upload and analyze NPS surveys to gauge customer satisfaction.',
      type: 'survey',
      path: '/survey/upload_survey_data',
    },
    {
      title: 'Customer Feedback Integration',
      description: 'Integrate with platforms like Zendesk to analyse customer feedback.',
      type: 'feedback',
      path: '/feedback',
    },
    {
      title: 'Product Request & Issues map',
      description: 'View product request and issues by customers',
      type: 'reports',
      path: '/feedback',
    },
    {
      title: 'Build Product Roadmaps',
      description: 'Easily plan and share your product development roadmap.',
      type: 'roadmap',
      path: '/roadmaps',
    },


    // { title: 'Initiate Surveys', description: 'Create and send surveys directly to gather customer insights.', type: 'customSurvey', path: '/surveys' },
  ];

  return (
    <>
      <PageHeader>
        <h1>Welcome to ClientCues Platform</h1>
        <p>You are currently on the {activePlan.product_plan} plan, and can do the following</p>
      </PageHeader>
      <PageContainer>
        {features.map((feature, index) => (
          <FeatureSquare key={index} feature={feature} />
        ))}
      </PageContainer>
    </>
  );
};

export default GetStartedPage;